@if(neighborhoodService.currentNeighborhood) {
  <div class="container-fluid pt-4">
    <div class="row">

      <div class="col-12 text-secondary mb-1">
        <small><b>
          Configuración pagos
        </b></small>
      </div>

      <div class="col-12 bg-white px-3 rounded mb-4 py-3">
        <div class="row">

          <div class="col-12 col-md-6 mb-3">
            <label class="form-label">
              Costo de mantenimiento
            </label>
            <input
              type="number"
              class="form-control"
              (keyup.enter)="update()"
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.maintenanceFee"
              placeholder="Costo de mantenimiento">
          </div>

          <div class="col-12 col-md-6 mb-3 d-flex align-items-center">
            <div class="row w-100">
              <div class="col d-flex align-items-center">
                Cobros automáticos
              </div>
              <div class="col-auto text-end d-flex align-items-center justify-content-end">
                <p-inputSwitch
                  [(ngModel)]="this.neighborhoodService.currentNeighborhood!.autoCharging"
                  (onChange)="update()"></p-inputSwitch>
              </div>
            </div>
          </div>

          @if(neighborhoodService.currentNeighborhood!.autoCharging) {
            <div class="col-12 col-md-6 mb-3 d-flex align-items-center">
              <div class="row w-100">
                <div class="col d-flex align-items-center">
                  Inactivar accesos automáticamente de morosos
                </div>
                <div class="col-auto text-end d-flex align-items-center justify-content-end">
                  <p-inputSwitch
                    [(ngModel)]="this.neighborhoodService.currentNeighborhood!.autoInactivateHouses"
                    (onChange)="update()"></p-inputSwitch>
                </div>
              </div>
            </div>
          }

          <!-- Acumular deuda -->
          <div class="col-12 col-md-6">
            <label class="form-label fw-semibold">Acumular deuda de residentes</label>
            <div class="d-flex align-items-center gap-2">
              <p-inputSwitch
                [(ngModel)]="neighborhoodService.currentNeighborhood!.accumulatesDebt">
              </p-inputSwitch>
              <small class="text-secondary">
                Muestra el total de adeudo por casa en la sección de pagos y registra movimientos de deuda al crear cargos
              </small>
            </div>
          </div>

          <div class="col-12">
            <button
              class="btn btn-success w-100 d-flex align-items-center justify-content-center"
              (click)="update()">
              <i class="material-icons me-2">save</i>
              Guardar
            </button>
          </div>

        </div>
      </div>

      <!-- Pasarela de pago -->
      @if(authService.currentUser?.profile === 'sudo') {
        <div class="col-12 text-secondary mb-1">
          <small><b>Pasarela de pagos</b></small>
        </div>

        <div class="col-12 bg-white px-3 rounded mb-4 py-3">
          <div class="row">

            <div class="col-12 col-md-6 mb-3 d-flex align-items-center">
              <div class="row w-100">
                <div class="col d-flex align-items-center">
                  Cobro con pasarela de pago
                </div>
                <div class="col-auto text-end d-flex align-items-center justify-content-end">
                  <p-inputSwitch
                    [(ngModel)]="neighborhoodService.currentNeighborhood!.paymentGatewayEnabled"></p-inputSwitch>
                </div>
              </div>
            </div>

            @if(neighborhoodService.currentNeighborhood!.paymentGatewayEnabled) {
              <div class="col-12 col-md-6 mb-3">
                <label class="form-label">Proveedor</label>
                <select
                  class="form-select"
                  [(ngModel)]="neighborhoodService.currentNeighborhood!.paymentGatewayProvider">
                  <option [ngValue]="null">Seleccionar proveedor</option>
                  <option value="conekta">Conekta</option>
                </select>
              </div>
            }

            @if(neighborhoodService.currentNeighborhood!.paymentGatewayEnabled &&
                neighborhoodService.currentNeighborhood!.paymentGatewayProvider) {
              <div class="col-12 col-md-6 mb-3">
                <label class="form-label">API Key</label>
                <input
                  type="password"
                  class="form-control"
                  [(ngModel)]="neighborhoodService.currentNeighborhood!.paymentGatewayApiKey"
                  placeholder="••••••••">
              </div>
            }

            <div class="col-12">
              <button
                class="btn btn-success w-100 d-flex align-items-center justify-content-center"
                (click)="update()">
                <i class="material-icons me-2">save</i>
                Guardar
              </button>
            </div>

          </div>
        </div>
      }

      <!-- Cobros automatizados -->
      @if(neighborhoodService.currentNeighborhood!.autoCharging) {
        <app-charge-cycles-page></app-charge-cycles-page>
      } <!-- end @if autoCharging -->

    </div>
  </div>

}
